














import Getters from '@/mixins/Getters'
import { Component, Vue, Mixins, Watch } from 'vue-property-decorator'

@Component
export default class SendSuccess extends Mixins(Getters) {
  // Reset on close
  protected close() {
    this.dataStore.commitHash(null)
  }
}
